import { propStore } from '../util';

export default function toggleInlineSurveyButtonToState(settings, disabled): void {
    const inlineSurveyButtonQuery = `.${settings.classNames.surveyButtonWrap} a`;
    const buttons = Array.from(document.querySelectorAll(inlineSurveyButtonQuery));

    buttons.forEach(button => {
        if (disabled) {
            if (button.className !== settings.classNames.inlineSurveyLinksDisabled) {
                propStore.backup(button, settings.classNames.inlineSurveyLinksDisabled);
            }
        }
        else {
            propStore.restore(button);
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/inlineSurveyButton.ts